'use client';

import Image from 'next/image';
import Link from 'next/link';

export const Footer = () => {
  return (
    <div className='container mx-auto px-[12px] lg_px-0'>
      <div className='grid grid-cols-1 gap-[20px] lg_grid-cols-3'>
        {[
          {
            image: '/about-us/footer-1.png',
            buttonText: "Shop Men's",
            href: '/mens-boots',
          },
          {
            image: '/about-us/footer-2.png',
            buttonText: "Shop Women's",
            href: '/womens-boots',
          },
          {
            image: '/about-us/footer-3.png',
            buttonText: "Shop Kids'",
            href: '/kids-boots',
          },
        ].map((item, index) => (
          <div
            key={index}
            className='relative'
          >
            <Image
              src={item.image}
              alt='about-us-new-page'
              width={470}
              height={340}
              className='h-[254px] w-full object-cover lg_h-[340px] '
            />
            <Link
              className='duration-300 absolute bottom-[15px] left-[15px] h-[40px] w-[145px]  rounded-full bg-white text-center font-roboto-medium text-[16px] font-medium leading-[40px] text-black transition-colors hover_bg-black hover_text-white lg_bottom-[20px] lg_left-[18px] lg_h-[50px] lg_w-[180px] lg_leading-[50px]'
              href={item.href}
            >
              {item.buttonText}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
